import { heDecodeOrDefault } from "~/lib/shared/html-utils";
import { ChartPost } from "~/types/asgard/ChartPost";
import { EvervizChartProps } from "./EvervizChart";

export type TrackerBlockToEvervizChartRequest = {
  headline?: string;
  headlineId?: string;
  chart: ChartPost;
};

export const apiChartToEvervizChartProps = ({
  headline,
  headlineId,
  chart,
}: TrackerBlockToEvervizChartRequest): EvervizChartProps => {
  const props: EvervizChartProps = {
    chartId: heDecodeOrDefault(chart.chart.chartId),
    footnote: heDecodeOrDefault(chart.footnote),
    headline: heDecodeOrDefault(headline),
    headlineId: heDecodeOrDefault(headlineId),
    image:
      chart.chart.chartDisplayType === "embed"
        ? null
        : heDecodeOrDefault(chart.chart.chartImage?.source),
    altText: heDecodeOrDefault(chart.chart.chartImage?.altText),
    injectId: heDecodeOrDefault(chart.chart.injectId),
    logo: heDecodeOrDefault(chart.logo),
    methodology: heDecodeOrDefault(chart.methodology),
    subtitle: heDecodeOrDefault(chart.subhead),
    title: heDecodeOrDefault(chart.chartTitle),
    hideHeadline: chart.hideHeadline,
  };
  return props;
};
